<!-- Hideo - the Vue shell: computer sidebar in place; top right controls (computer), phone bar and menu and the create button
     on top of the page; the dialogs moved to Vue (DialogHost, teleported to <body> by each dialog); the guided tour
     (TourOverlay); the app dialogs, the thumbs-up and the notice at the bottom (NoticeLayer); the listeners of files and
     links dropped on the pages (installDrops, src/stores/drop.ts).
     Pages are drawn by the RouterView inside <main>. A legal page shown before a profile is chosen is on its own: no
     menus, top controls or create button (src/features/legal.ts; LegalPage.vue draws its own top bar). -->
<script setup lang="ts">
import SideNav from './components/SideNav.vue'
import TopControls from './components/TopControls.vue'
import MobileBar from './components/MobileBar.vue'
import MobileMenu from './components/MobileMenu.vue'
import CreateButton from './components/CreateButton.vue'
import DialogHost from './components/DialogHost.vue'
import NoticeLayer from './components/notices/NoticeLayer.vue'
import TourOverlay from './components/TourOverlay.vue'
import { computed, onMounted } from 'vue'
import { installDrops } from './stores/drop'
import { legalOnly } from './features/legal'

const shell = computed(() => !legalOnly())

onMounted(installDrops)   // after the children: the script editor's text exists by then
</script>

<template>
  <SideNav v-if="shell" />
  <Teleport to="main">
    <RouterView />
  </Teleport>
  <Teleport to="body">
    <template v-if="shell">
      <TopControls />
      <MobileBar />
      <MobileMenu />
      <CreateButton />
    </template>
  </Teleport>
  <DialogHost />
  <TourOverlay />
  <NoticeLayer />
</template>
